import { useEffect, useState, FunctionComponent } from 'react'

import AccordionContainer from 'components/accordion/AccordionContainer'
import { TopLevelAccordionContainerProps } from 'redux/containers/components/accordion/TopLevelAccordionContainer'

const TopLevelAccordion: FunctionComponent<TopLevelAccordionProps> = ({
  group,
  eventCategory,
  highlight,
  flavourColor,
  cxNames,
  expandedNodeId,
  showAllS1 = false,
  canAccess,
  setUserRolesModalIsOpen
}) => {
  const [nodes, setNodes] = useState(group)

  useEffect(() => {
    setNodes(expandedNodeId ? group.filter((node: { id: string }) => node.id === expandedNodeId) : group)
  }, [expandedNodeId, setNodes, group])

  useEffect(() => {
    if (!canAccess) {
      setUserRolesModalIsOpen(true)
    }
  }, [canAccess])

  return (
    <AccordionContainer
      key='accordion'
      {...{ eventCategory, highlight, flavourColor, cxNames, showAllS1 }}
      group={showAllS1 ? group : nodes}
    />
  )
}

interface TopLevelAccordionProps extends TopLevelAccordionContainerProps{
  flavourColor: string;
  cxNames: any;
  showAllS1: boolean;
}

export default TopLevelAccordion
